import { z } from 'zod'
import type { AppRevokeLicensePayload } from '../../models/AppRevokeLicensePayload'

export const AppRevokeLicenseDTO = z.object({
  user_id: z.number().optional(),
  password: z.string(),
  confirm_phrase: z.string()
})

export type AppRevokeLicenseDTO = z.infer<typeof AppRevokeLicenseDTO>

export function mapAppRevokeLicenseToDTO (model: AppRevokeLicensePayload): AppRevokeLicenseDTO {
  return {
    user_id: model.userId,
    password: model.password,
    confirm_phrase: model.confirmPhrase
  }
}

export function mapDTOToAppRevokeLicense (dto: AppRevokeLicenseDTO): AppRevokeLicensePayload {
  return {
    userId: dto.user_id,
    password: dto.password ?? '',
    confirmPhrase: dto.confirm_phrase ?? ''
  }
}
